// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ProfileAdminTools":"iz_a bhp_vu bhp_ql bhp_va bhp_gy bhp_kg bhp_sv","ProfileAdminTools__item":"iz_b"};